"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _reactHookForm = require("react-hook-form");

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _MailOutline = _interopRequireDefault(require("@material-ui/icons/MailOutline"));

var _PhoneOutlined = _interopRequireDefault(require("@material-ui/icons/PhoneOutlined"));

var _SupervisorAccountOutlined = _interopRequireDefault(require("@material-ui/icons/SupervisorAccountOutlined"));

var _validators = _interopRequireDefault(require("@jobmatchme/ui/es/utils/validators"));

var _TextFieldWrapper = _interopRequireDefault(require("../../TextFieldWrapper"));

var _GenderAndName = _interopRequireDefault(require("../GenderAndName"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FormEditUser = function FormEditUser(_ref) {
  var t = _ref.t,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$withPosition = _ref.withPosition,
      withPosition = _ref$withPosition === void 0 ? false : _ref$withPosition,
      _ref$errorStyle = _ref.errorStyle,
      errorStyle = _ref$errorStyle === void 0 ? _styleModule.default.error : _ref$errorStyle,
      _ref$translateNs = _ref.translateNs,
      translateNs = _ref$translateNs === void 0 ? 'ui' : _ref$translateNs,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? true : _ref$disabled,
      _ref$emailDisplayOnly = _ref.emailDisplayOnly,
      emailDisplayOnly = _ref$emailDisplayOnly === void 0 ? false : _ref$emailDisplayOnly;

  var _useFormContext = (0, _reactHookForm.useFormContext)(),
      register = _useFormContext.register,
      errors = _useFormContext.formState.errors,
      getValues = _useFormContext.getValues;

  var componentNs = "".concat(translateNs, ":ui.Form.EditUser");

  var checkPhoneNumber = function checkPhoneNumber(val) {
    return (0, _validators.default)('phone')(val);
  };

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      validationStatus = _useState2[0],
      setValidationStatus = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.editUser,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GenderAndName.default, {
      gender: user.salutation,
      defaultValueName: user.name,
      translateNs: translateNs,
      t: t
    }, "name"), !(user || {}).name && !getValues('name') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Error.default, {
      className: _styleModule.default.errorIcon
    }), errors.name && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: errorStyle,
      children: t("".concat(componentNs, ".error.name"))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextFieldWrapper.default, {
      type: "email",
      useTouched: true,
      defaultValue: user.email,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MailOutline.default, {
        style: {
          color: disabled ? '#c9c7d3' : ''
        }
      }),
      inputProps: emailDisplayOnly ? {} : register('email', {
        required: true
      }),
      placeholder: t("".concat(componentNs, ".placeholders.email")),
      disabled: disabled
    }), !(user || {}).email && !getValues('email') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Error.default, {
      className: _styleModule.default.errorIcon
    }), errors['email'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: errorStyle,
      children: t("".concat(componentNs, ".error.email"))
    }), withPosition ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextFieldWrapper.default, {
      type: "text",
      name: "position",
      placeholder: t("".concat(componentNs, ".placeholders.position")),
      useTouched: true,
      defaultValue: user.position,
      inputProps: register('position'),
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SupervisorAccountOutlined.default, {})
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextFieldWrapper.default, {
      useTouched: true,
      type: "phone",
      name: "phone_number",
      onChange: function onChange(event) {
        setValidationStatus(checkPhoneNumber(event.target.value));
      },
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PhoneOutlined.default, {}),
      defaultValue: user.phone_number,
      inputProps: register('phone_number', {
        validate: function validate(value) {
          return value === '' || checkPhoneNumber(value);
        }
      }),
      placeholder: t("".concat(componentNs, ".placeholders.phone_number"))
    }), (errors['phone_number'] || !validationStatus) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: errorStyle,
      children: t("".concat(componentNs, ".error.phone_number"))
    })]
  });
};

var _default = FormEditUser;
exports.default = _default;